var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapeVerde(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#13348f",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#bf312d",
    d: "M0 13h30v4H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 12h30v2H0zm0 4h30v2H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7d116",
    d: "m5.98 15.86.24.74H7l-.63.46.24.75-.63-.47-.64.46.25-.74-.64-.46h.78zm-.07-3.9.25.74h.78l-.64.46.25.75-.64-.46-.63.46.24-.75-.63-.46h.78zm11.1 0 .24.74h.78l-.63.46.24.75-.63-.46-.64.46.24-.75-.63-.46h.78zm-.08 3.9.25.74h.78l-.64.46.25.74-.64-.46-.63.46.24-.74-.64-.46h.79zm-5.47-7.9.24.74h.79l-.64.46.24.75-.63-.47-.64.47.24-.75-.63-.46h.78zm0 11.68.24.75h.79l-.64.46.24.75-.63-.46-.64.46.25-.75-.64-.46h.79zM8.03 9.07l.24.74h.79l-.64.46.24.75-.63-.46-.64.46.25-.75L7 9.81h.78zm6.85 9.46.24.75h.79l-.63.46.24.75-.64-.46-.63.46.24-.75-.63-.46h.78zm-6.73.1.24.74h.79l-.64.46.24.75-.63-.47-.64.47.25-.75-.64-.46h.79zm6.63-9.65.25.75h.78l-.63.46.24.74-.64-.46-.63.46.24-.74-.63-.46h.78z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapeVerde);
export default __webpack_public_path__ + "static/media/cape-verde.4bb47e0b71b7dbf8c82b6517059dbca1.svg";
export { ForwardRef as ReactComponent };